import { NguyenVongService } from "../services/nguyenvong.service";
const nguyenvong = {
	coSoId: null,
	nganhId: "",
	toHopId: "",
	tenToHop: "",
	diemXetTuyen: -1,
	diem11: 0,
	diem12: 0,
	diem13: 0,
	diem21: 0,
	diem22: 0,
	diem23: 0,
	diem31: 0,
	diem32: 0,
	diem33: 0,
	thuTu: 1,
	maToHop: "",
	diemM1: 0,
	diemM2: 0,
	diemM3: 0,
}
var state = {
	nguyenvongs: [
		{ ...nguyenvong }
	],
	nguyenvong: { nganhId: "", toHopId: "", tenToHop: "", coSoId: "", fileDinhKemCcnn: null},
	nguyenvongs_old: [],
};

var getters = {};

var mutations = {
	themNguyenVong(state) {
		state.nguyenvongs.push({ ...state.nguyenvong });
	},
	async xoaNguyenVong(state, index) {
		let old_nguyenvongs = await [...state.nguyenvongs];
		state.nguyenvongs = [];
		state.nguyenvongs = await old_nguyenvongs.filter((value, ind) => {
			if (index !== ind) return value;
		});
	},
	updateNganhId(state, { index, id }) {
		state.nguyenvongs[index].nganhId = id;
	},
	updateToHopId(state, { index, id }) {
		state.nguyenvongs[index].toHopId = id;
	},

	updateCoSoId(state, { index, id }) {
		state.nguyenvongs[index].coSoId = id;
	},

	updateTenToHop(state, { toHopId, tenToHop, maToHop }) {
		state.nguyenvongs.forEach((item) => {
			if (item.toHopId === toHopId) {
				item.tenToHop = tenToHop;
				item.maToHop = maToHop;
			}
		});
	},

	updateDiemXetTuyen(state, { diems, mons }) {
		state.nguyenvongs.forEach((item, index) => {
			let diemxettuyen = 0;
			let monhocs = item.tenToHop.split(" - ");
			monhocs.forEach((mon, tt) => {
				let ind = mons.indexOf(mon);
				let dtb = 0;
				state.nguyenvongs[index][`diem${tt + 1}1`] = parseFloat(diems[ind].diem1);
				state.nguyenvongs[index][`diem${tt + 1}2`] = parseFloat(diems[ind].diem2);
				state.nguyenvongs[index][`diem${tt + 1}3`] = parseFloat(diems[ind].diem3);
				state.nguyenvongs[index][`diem${tt + 1}`] = parseFloat(diems[ind].diemM);
				dtb = parseFloat(diems[ind].diemM) > 0 ? parseFloat(diems[ind].diemM).toFixed(2) * 1 : ((parseFloat(diems[ind].diem1) + parseFloat(diems[ind].diem2) + parseFloat(diems[ind].diem3)) / 3).toFixed(2) * 1;
				diemxettuyen += dtb;
			});
			state.nguyenvongs[index].diemXetTuyen = diemxettuyen.toFixed(2) * 1  /// 3;
			state.nguyenvongs[index].thuTu = index + 1;
		});
	},

	saveNguyenVong(state, data) {
		state.nguyenvongs = [...data];
	},

	saveNguyenVongOld(state, data) {
		state.nguyenvongs_old = [...data];
	},
  
  saveNguyenVongCaoHoc(state, data){
    if(data.length > 0){
      state.nguyenvong = {...data[0]};
    }
	},
	
	updateFileDinhKemCcnn(state, data) {
		state.nguyenvong.fileDinhKemCcnn = [...data]
	},

  updateCoSoNguyenVong(state, value){
    state.nguyenvong.coSoId = value;
  },

	loadNew(state) {
		state.nguyenvongs = [
			{ ...nguyenvong }
		];
    state.nguyenvong = {...nguyenvong}
	},
};

var actions = {
	layThongTinNguyenVong({ state }, index) {
		return { ...state.nguyenvongs[index] };
	},
	updateNganhId({ commit }, { index, id }) {
		commit("updateNganhId", { index, id });
	},
	updateToHopId({ commit }, { index, id }) {
		commit("updateToHopId", { index, id });
	},
	updateCoSoId({ commit }, { index, id }) {
		commit("updateCoSoId", { index, id });
	},

	updateTenToHop({ commit }, { toHopId, tenToHop, maToHop }) {
		commit("updateTenToHop", { toHopId, tenToHop, maToHop });
	},

	updateDiemXetTuyen({ commit }, { diems, mons }) {
		commit("updateDiemXetTuyen", { diems, mons });
	},

	async createNguyenVongs(
		{ rootState, state, dispatch },
		{ diems, mons, thiSinhId },
	) {
		await dispatch("updateDiemXetTuyen", { diems, mons });
		return NguyenVongService.createNguyenVongs({
			nguyenvongs: state.nguyenvongs,
			thiSinhId: thiSinhId,
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
		})
			.then((response) => response)
			.catch((error) => error);
	},

	async getNguyenVongsByThiSinhId({ commit, dispatch }, data) {

		await commit("saveNguyenVong", [...data]);
		await commit("saveNguyenVongOld", [...data]);
		await dispatch("tohop/getDiemVaToHop", null, { root: true });
	},

	saveNewNguyenVongs({ dispatch, state }, { diems, mons, thiSinhId }) {
		return NguyenVongService.deleteNguyenVongs(state.nguyenvongs_old)
			.then(() => {
				return dispatch("createNguyenVongs", { diems, mons, thiSinhId }).then(
					(response) => response,
				);
			})
			.catch((error) => error.message);
	},

	getNguyenVongsByThiSinhIdAndDotId({ commit }, { thiSinhId, dotDangKyId }) {
		return NguyenVongService.getNguyenVongsByThiSinhIdAndDotId(
			thiSinhId,
			dotDangKyId,
		)
			.then((response) => {
				if (response.status === 200) commit("saveNguyenVongOld", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
